/* Inéa · campagnes datées (bandeau + ligne au-dessus du bouton d'achat).
   Les dates sont saisies en heure de Paris (« AAAA-MM-JJ HH:MM »). Hors période, rien ne s'affiche. */
(function () {
  var root = document.querySelector('[data-iv4-announce]');
  if (!root) return;

  function parisOffset(ms) {
    try {
      var parts = new Intl.DateTimeFormat('en-US', {
        timeZone: 'Europe/Paris', hourCycle: 'h23',
        year: 'numeric', month: '2-digit', day: '2-digit', hour: '2-digit', minute: '2-digit', second: '2-digit'
      }).formatToParts(new Date(ms));
      var v = {};
      parts.forEach(function (p) { v[p.type] = parseInt(p.value, 10); });
      return Date.UTC(v.year, v.month - 1, v.day, v.hour, v.minute, v.second) - ms;
    } catch (e) {
      return 3600000;
    }
  }

  function parseParis(str) {
    var m = /^\s*(\d{4})-(\d{1,2})-(\d{1,2})(?:[ T](\d{1,2})[:h](\d{2}))?\s*$/.exec(str || '');
    if (!m) return NaN;
    var guess = Date.UTC(+m[1], +m[2] - 1, +m[3], +(m[4] || 0), +(m[5] || 0));
    return guess - parisOffset(guess);
  }

  var campaigns = Array.prototype.map.call(root.querySelectorAll('template[data-iv4-campaign]'), function (t) {
    return {
      start: parseParis(t.dataset.start),
      end: parseParis(t.dataset.end),
      text: t.content ? t.content.textContent : t.textContent,
      link: t.dataset.link || '',
      hours: parseInt(t.dataset.countdown, 10) || 0,
      product: t.dataset.product || '',
      detail: t.dataset.detail || '',
      label: t.dataset.label || '',
      style: t.dataset.style || '',
      cta: t.dataset.cta || ''
    };
  }).filter(function (c) { return !isNaN(c.start) && !isNaN(c.end) && c.end > c.start; });
  if (!campaigns.length) return;

  // ?iv4_date=AAAA-MM-JJ simule une date, uniquement sur un thème non publié (aperçu).
  var shift = 0;
  try {
    var sim = new URLSearchParams(window.location.search).get('iv4_date') || window.IV4_PREVIEW_DATE;
    var role = window.Shopify && window.Shopify.theme && window.Shopify.theme.role;
    if (sim && role && role !== 'main') {
      var t0 = parseParis(sim.length <= 10 ? sim + ' 12:00' : sim);
      if (!isNaN(t0)) shift = t0 - Date.now();
    }
  } catch (e) {}
  function clock() { return Date.now() + shift; }

  var def = root.querySelector('[data-ref="default"]');
  var slots = document.querySelectorAll('[data-iv4-urgency]');
  var current = null;
  var bar = null;
  var timer = null;

  function pad(n) { return (n < 10 ? '0' : '') + n; }

  function left(ms, short) {
    var s = Math.max(0, Math.floor(ms / 1000));
    var d = Math.floor(s / 86400), h = Math.floor((s % 86400) / 3600), m = Math.floor((s % 3600) / 60), sec = s % 60;
    var t = d > 0 ? d + ' j ' + pad(h) + ' h ' + pad(m) + ' min' : pad(h) + ' h ' + pad(m) + ' min ' + pad(sec) + ' s';
    return short ? 'encore ' + t : 'Plus que ' + t;
  }

  function active(now) {
    for (var i = 0; i < campaigns.length; i++) {
      if (now >= campaigns[i].start && now < campaigns[i].end) return campaigns[i];
    }
    return null;
  }

  var GIFT = '<svg viewBox="0 0 24 24" width="16" height="16" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><rect x="3" y="8" width="18" height="4" rx="1"/><path d="M12 8v13M19 12v7a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2v-7"/><path d="M7.5 8a2.5 2.5 0 0 1 0-5C10 3 12 8 12 8s2-5 4.5-5a2.5 2.5 0 0 1 0 5"/></svg>';

  function node(tag, cls, text) { var e = document.createElement(tag); if (cls) e.className = cls; if (text) e.textContent = text; return e; }
  function cdNode(tiles) { var d = node('span', 'iv4-urg-cd' + (tiles ? ' iv4-urg-tiles' : '')); d.setAttribute('data-cd', tiles ? 'tiles' : ''); d.hidden = true; return d; }

  function build(c) {
    if (bar) bar.remove();
    bar = null;
    root.classList.remove('is-bf');
    slots.forEach(function (s) { s.hidden = true; s.textContent = ''; s.classList.remove('is-bf'); });
    if (!c) { def.hidden = false; return; }
    def.hidden = true;
    var bf = c.style === 'bf';
    root.classList.toggle('is-bf', bf);
    bar = node('div', 'iv4-wrap iv4-urg');
    if (c.label) bar.appendChild(node('span', 'iv4-urg-pill', c.label));
    var main = node(c.link ? 'a' : 'span', 'iv4-urg-txt', c.text);
    if (c.link) main.href = c.link;
    bar.appendChild(main);
    bar.appendChild(cdNode(false));
    root.appendChild(bar);
    if (!c.product) return;
    slots.forEach(function (s) {
      s.classList.toggle('is-bf', bf);
      if (bf) {
        var head = node('span', 'urg-head');
        var pill = node('span', 'iv4-urg-pill'); pill.innerHTML = GIFT; pill.appendChild(document.createTextNode(c.label || 'Offre'));
        head.appendChild(pill);
        head.appendChild(cdNode(true));
        s.appendChild(head);
        s.appendChild(node('span', 'urg-title', c.product));
        if (c.detail) s.appendChild(node('span', 'urg-detail', c.detail));
        if (c.cta && c.link) { var a = node('a', 'urg-cta', c.cta); a.href = c.link; s.appendChild(a); }
      } else {
        s.appendChild(node('span', '', c.product));
        s.appendChild(cdNode(false));
      }
      s.hidden = false;
    });
  }

  function tilesHtml(ms) {
    var s = Math.max(0, Math.floor(ms / 1000));
    var parts = [[Math.floor(s / 86400), 'j'], [Math.floor((s % 86400) / 3600), 'h'], [Math.floor((s % 3600) / 60), 'min'], [s % 60, 's']];
    return parts.map(function (p) { return '<span class="t"><b>' + pad(p[0]) + '</b><small>' + p[1] + '</small></span>'; }).join('');
  }

  function tick() {
    var now = clock();
    var c = active(now);
    if (c !== current) { current = c; build(c); }
    if (!c) return;
    var rest = c.end - now;
    var show = c.hours > 0 && rest <= c.hours * 3600000;
    document.querySelectorAll('[data-iv4-announce] [data-cd], [data-iv4-urgency] [data-cd]').forEach(function (el) {
      if (!show) el.textContent = '';
      else if (el.getAttribute('data-cd') === 'tiles') el.innerHTML = tilesHtml(rest);
      else el.textContent = left(rest, !!el.closest('[data-iv4-announce]'));
      el.hidden = !show;
    });
  }

  tick();
  timer = setInterval(tick, 1000);
  document.addEventListener('visibilitychange', function () { if (!document.hidden) tick(); });
})();
